import { render, staticRenderFns } from "./InfoConsultaMotorSiisa.vue?vue&type=template&id=06cba2f0"
import script from "./InfoConsultaMotorSiisa.vue?vue&type=script&lang=js"
export * from "./InfoConsultaMotorSiisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports